/* Logic - Sunday workshops can only be booked if order contains Saturday Tickets. */
/* Logic - The max amount of workshops that can be booked each for "Morning" and "Afternoon" is based on the total Saturday tickets in the order. */

import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api, getEventById, getEventInfosByEventId, getTicketTypesByEventId, getTicketTypeInfosByTicketTypeId, getTicketTypeNumberOfAvailableTickets } from "ticketino-api-client";
import axios from "axios";

import Header from "./components/Header";
import Footer from "./components/Footer";
import Loading from "./components/Loading";

import imgIconProgressCompleted from "../images/progress-bar/ball-completed.svg";
import imgIconProgress from "../images/progress-bar/ball-progress.svg";

import imgIconInfo from "../images/icons/info.svg";
import imgIconAdd from "../images/icons/add.svg";
import imgIconRemove from "../images/icons/remove.svg";


const WorkshopsSaturday = () => {
    const [token] = useState(sessionStorage.getItem("token"));

    const [orderId] = useState(sessionStorage.getItem("orderId"));
    const [order, setOrder] = useState({});

    const [posId, setPosId] = useState();
    const [eventId, setEventId] = useState();
    const [eventIdWorkshopsSaturday, setEventIdWorkshopsSaturday] = useState();
    const [event, setEvent] = useState({});

    const [ticketTypes, setTicketTypes] = useState([]);
    const [selectedTicketQuantities, setSelectedTicketQuantities] = useState([]);

    const [countSaturdayTickets] = useState(sessionStorage.getItem("countSaturdayTickets"));
    const [countSundayTickets] = useState(sessionStorage.getItem("countSundayTickets"));

    const [promotioncode] = useState(sessionStorage.getItem("addedPromotion"));

    const [moreInfo, setMoreInfo] = useState({});

    const [showWithoutWorkshopsButton, setShowWithoutWorkshopsButton] = useState(true);

    const [loading, setLoading] = useState(true);
    const [loaded, setLoaded] = useState(false);


    // react hook for navigation
    let navigate = useNavigate();

    // base url
    let baseUrl = process.env.REACT_APP_BASEURL_API;

    // setting the base url of the npm package api calls
    api.defaults.baseURL = baseUrl;

    // fetching resources
    const [resources, setResources] = useState({});

    // fetching params
    let { language } = useParams();

    let languageId = 0;

    // changing languageId according to the url
    switch (language) {
        case ("de" || "DE"):
            languageId = 1;
            break;
        case ("en" || "EN"):
            languageId = 3;
            break;
        default:
            languageId = 0;
            language = "de";
            break;
    }

    useEffect(() => {
        requestFormSettings();
    }, []);

    useEffect(() => {
        setTicketTypes([]);
    }, []);

    useEffect(() => {
        requestResources();
    }, [language]);

    useEffect(() => {
        axios.defaults.headers.common["Authorization"] = "Bearer " + token;
        api.defaults.headers.common['Authorization'] = "Bearer " + token;

        if (orderId && eventIdWorkshopsSaturday) {
            loadOrder(orderId);
            loadEvent(eventIdWorkshopsSaturday, orderId)
        }
    }, [orderId, eventIdWorkshopsSaturday]);

    useEffect(() => {
        if (eventIdWorkshopsSaturday && ticketTypes) {
            const performTicketCleanup = async () => {
                if (orderId && ticketTypes.length > 0) {
                    const ticketsDeleted = await deleteOrderTickets(orderId);
                    if (ticketsDeleted) await loadOrder(orderId);
                }
            };

            setSelectedTicketQuantities([]);
            performTicketCleanup();
        }
    }, [ticketTypes]);

    const requestFormSettings = async () => {
        await axios.get(`form/formsettings`).then((res) => {
            setEventId(res.data.eventId);
            setEventIdWorkshopsSaturday(res.data.eventIdWorkshopsSaturday);
        });
    };

    const requestResources = async () => {
        await axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setResources(res.data?.translation);
            })
            .catch((error) => console.error(error.response.data));
    };

    const loadOrder = async (orderId) => {
        try {
            const updatedOrder = await getOrderByOrderId(orderId);
            setOrder(updatedOrder);

            //stay in the page if promocode is "WORKSHOP"
            if ((!updatedOrder?.tickets || updatedOrder.tickets.length === 0) && promotioncode.toLocaleLowerCase() !== "workshop") {
                navigate(`/${language}/home`);
            }
        } catch (error) {
            console.error(error);
        }
    };

    const getOrderByOrderId = async (orderId) => {
        try {
            const res = await axios.get(`${baseUrl}/ShopBasket/Order/${orderId}`);
            return res.data;
        }
        catch (error) {
            console.error(error);
        }
    }

    const loadEvent = async (eventIdWorkshopsSaturday, orderId) => {
        try {
            setLoading(true);

            // Event
            const event = await getEventById(eventIdWorkshopsSaturday);
            const infos = await getEventInfosByEventId(eventIdWorkshopsSaturday);

            // sorting it according to the language
            const eventInfo = infos.eventInfos.find(info => info.languageId == languageId);

            // setting the eventInfo object in the info attribute of event
            const updatedEventInfo = { ...event, info: eventInfo };

            // TicketType
            const ticketTypes = await getTicketTypesByEventId(eventIdWorkshopsSaturday);

            const updatedTicketTypes = await Promise.all(
                ticketTypes.map(async (ticketType) => {
                    const info = await getTicketTypeInfosByTicketTypeId(ticketType.id);

                    // sorting it according to the language
                    const ticketTypeInfo = info.find(info => info.languageId == languageId) ?? info[0];

                    const ticketTypeAvailability = await getTicketTypeNumberOfAvailableTickets(ticketType.id, orderId);

                    // setting the ticketTypeInfo and ticketTypeAvailability object as attributes in ticketType (info and availability)
                    return { ...ticketType, info: ticketTypeInfo, availability: ticketTypeAvailability }
                })
            )

            // setting the values in the end
            setEvent(updatedEventInfo);
            setTicketTypes(updatedTicketTypes);
            setLoading(false);

        } catch (error) {
            console.error(error);
        }
    }

    const deleteOrderTickets = async () => {
        try {
            const response = await axios.get(`${baseUrl}/ShopBasket/Order/${orderId}`);
            const tickets = response.data.tickets;

            if (tickets.length > 0) {
                const ticketTypeIds = ticketTypes.map(tt => tt.id);
                const ticketsInOrder = tickets
                    .filter(ticket => ticketTypeIds.includes(ticket.ticketTypeId))
                    .map(ticket => ticket.id);

                if (ticketsInOrder.length > 0) {
                    const body = { TicketsToRemove: ticketsInOrder };
                    await axios.delete(`${baseUrl}/ShopBasket/Order/${orderId}/Tickets`, {
                        headers: { Accept: "application/json" },
                        data: body,
                    });

                    return true; // Tickets were deleted
                }
            }

            return false; // No relevant tickets to delete
        } catch (error) {
            console.error("Failed to delete order tickets:", error);
        }
    };

    const addTicketToBasket = async () => {
        let addTicketTypes = selectedTicketQuantities
            .filter(item => item.quantity > 0)
            .map(item => {
                const ticketType = ticketTypes.find(tt => tt.id === item.id);
                const option10Value = ticketType ? (ticketType.price + 15.00).toFixed(2) : "";

                return {
                    ticketTypeId: parseInt(item.id),
                    quantity: item.quantity,
                    option10: option10Value
                };
            });

        // Calculate total workshops selected
        const totalWorkshopsSelected = selectedTicketQuantities
            .filter(item => item.quantity > 0)
            .reduce((sum, item) => sum + item.quantity, 0);

        // Store in sessionStorage
        sessionStorage.setItem("totalSelectedWorkshopsSaturday", (totalWorkshopsSelected).toString());

        await axios
            .post(`${baseUrl}/ShopBasket/Order/${orderId}/Tickets`, {
                ticketsToAdd: addTicketTypes,
            })
            .then(() => {
                // gtm - addToCart
                //window.dataLayer = window.dataLayer || [];
                //window.dataLayer.push({
                //    event: 'addToCart',
                //});

                //skip sunday workshop if order doesnt contain sunday tickets
                if (countSundayTickets > 0) {
                    navigate(`/${language}/workshops-sunday`);
                } else {
                    navigate(`/${language}/address`);
                }
            })
            .catch((error) => {
                console.error(error.response?.data);
            });
    };

    const onSubmit = async () => {
        await addTicketToBasket();
    };

    const incrementTicket = (id, max, group) => {
        setSelectedTicketQuantities(prev => {
            const totalGroupQuantity = prev
                .filter(item => item.group === group)
                .reduce((sum, item) => sum + item.quantity, 0);

            const foundIndex = prev.findIndex(item => item.id === id);
            const currentItemQuantity = foundIndex === -1 ? 0 : prev[foundIndex].quantity;

            const canIncrement =
                totalGroupQuantity < countSaturdayTickets && // Group limit
                currentItemQuantity < max;                  // Per-ticket limit

            if (!canIncrement) return prev;

            let updated;

            if (foundIndex === -1) {
                // Not found: add new item with quantity 1
                updated = [...prev, { id, quantity: 1, group }];
            } else {
                // Found: update quantity but don't exceed max
                updated = [...prev];
                updated[foundIndex] = {
                    ...updated[foundIndex],
                    quantity: currentItemQuantity + 1,
                };
            }

            const hasAtLeastOne = updated.some(item => item.quantity > 0);
            setShowWithoutWorkshopsButton(!hasAtLeastOne);

            return updated;
        });
    };

    const decrementTicket = (id) => {
        setSelectedTicketQuantities(prev => {
            const foundIndex = prev.findIndex(item => item.id === id);
            if (foundIndex === -1) {
                return prev;
            }

            const updated = [...prev];
            const newQuantity = Math.max(updated[foundIndex].quantity - 1, 0);
            updated[foundIndex] = { ...updated[foundIndex], quantity: newQuantity };

            // Update showWithoutWorkshopsButton based on new state
            const hasAtLeastOne = updated.some(item => item.quantity > 0);
            setShowWithoutWorkshopsButton(!hasAtLeastOne);

            return updated;
        });
    };

    const mapTicketTypes = () => {
        if (!ticketTypes || ticketTypes.length === 0) return null;

        const ticketTypesSorted = [...ticketTypes]
            .filter(tt => tt.availability?.status === 0 || tt.availability?.status === 1)
            .sort((a, b) => a.sortOrder - b.sortOrder);

        // Separate ticket types into morning and noon based on the hour of the 'start'
        const morningTickets = ticketTypesSorted.filter(tt => {
            const hour = new Date(tt.start).getHours();
            return hour < 14; // before 13:00
        });

        const noonTickets = ticketTypesSorted.filter(tt => {
            const hour = new Date(tt.start).getHours();
            return hour >= 14; // 14:00 and later
        });

        const renderTicketGroup = (group, timePeriod) => (
            <>
                <div className="mt-4 mb-2">
                    <strong>{timePeriod}</strong>
                </div>
                {group.map((tt, index) => (
                    <div key={tt.id}>
                        <hr className="ticket-separator" />

                        <div className="d-flex justify-content-between align-items-center">
                            <div className="d-flex align-items-center flex-nowrap">
                                <div className="d-flex align-items-center gap-2">
                                    {tt.availability?.availableTickets === 0 ? (
                                        <span className="text-soldout">{resources?.SoldOut}</span>
                                    ) : (
                                        <>
                                            <button
                                                type="button"
                                                className="btn-counter"
                                                onClick={() => decrementTicket(tt.id)}
                                                disabled={(selectedTicketQuantities.find(item => item.id === tt.id)?.quantity || 0) <= 0}
                                            >
                                                <img src={imgIconRemove} alt="Decrease" width="16" height="16" />
                                            </button>

                                            <span className="ticket-quantity">
                                                {selectedTicketQuantities.find(item => item.id === tt.id)?.quantity || 0}
                                            </span>

                                            <button
                                                type="button"
                                                className="btn-counter"
                                                onClick={() => incrementTicket(tt.id, tt.availability?.availableTickets, timePeriod.toLowerCase())}
                                                disabled={(selectedTicketQuantities.find(item => item.id === tt.id)?.quantity || 0) >= tt.availability?.availableTickets}
                                            >
                                                <img src={imgIconAdd} alt="Increase" width="16" height="16" />
                                            </button>
                                        </>
                                    )}
                                </div>

                                <label className="ms-4 ticket-name-label">
                                    {tt.info?.name}
                                </label>
                            </div>

                            <label className="text-nowrap">
                                {tt.currency} {(tt.price + 15).toFixed(2)}
                            </label>
                        </div>

                        {index === group.length - 1 && <hr className="ticket-separator" />}
                    </div>
                ))}
            </>
        );

        return (
            <>
                {!loading && morningTickets.length > 0 && (
                    <>
                        <div className="row mt-4">
                            <div className="col-md-12">
                                <strong>
                                    {resources?.WorkshopsSaturday}
                                </strong>
                            </div>
                        </div>
                        <div className="row tickets-box mt-2">
                            <div className="col-md-12">
                                {renderTicketGroup(morningTickets, resources?.WorkshopsMorningSaturday)}
                            </div>
                        </div>
                    </>
                )}

                {!loading && noonTickets.length > 0 && (
                    <>
                        <div className="row mt-5">
                            <div className="col-md-12">
                                <strong>
                                    {resources?.WorkshopsSaturday}
                                </strong>
                            </div>
                        </div>
                        <div className="row tickets-box mt-2">
                            <div className="col-md-12">
                                {renderTicketGroup(noonTickets, resources?.WorkshopsNoonSaturday)}
                            </div>
                        </div>
                    </>
                )}
            </>
        );
    };

    const ButtonNextWithoutWorkshopsWhite = (
        <button
            className="btn btn-custom btn-custom-workshops-white"
            onClick={() => {
                //skip sunday workshop if order doesnt contain sunday tickets
                if (countSundayTickets > 0) {
                    navigate(`/${language}/workshops-sunday`);
                } else {
                    navigate(`/${language}/address`);
                }
            }}
        >
            {resources?.WorkshopNextWithout}
        </button>
    );

    const ButtonNextWithWorkshops = (
        <button
            className="btn btn-custom"
            onClick={() => onSubmit()}
        >
            {resources?.Next}
        </button>
    );

    const onBackClick = async () => {
        navigate(-1)
    }

    return (
        <>
            <Header language={language} pagePath="workshops-saturday" />
            <div className="page-container">

                {/* progress bar */}
                <div className="progressbar-wrapper">
                    <div className="progressbar-lines">
                        <div className="line" />
                        <div className="line" />
                        <div className="line" />
                    </div>

                    <div className="progressbar-steps">
                        <div className="progress-step completed cursor-pointer" onClick={() => navigate(`/${language}/home`)}>
                            <div className="circle">
                                <img src={imgIconProgressCompleted} alt="Step 1" />
                            </div>
                            <div className="label">{resources?.ProgressTickets}</div>
                        </div>

                        <div className="progress-step active">
                            <div className="circle">
                                <img src={imgIconProgressCompleted} alt="Step 2" />
                            </div>
                            <div className="label">
                                {resources?.ProgressWorkshops}<br />{resources?.ProgressOptional}
                            </div>
                        </div>

                        <div className="progress-step">
                            <div className="circle">
                                <img src={imgIconProgress} alt="Step 3" />
                            </div>
                            <div className="label">{resources?.ProgressAdditionalInformation}</div>
                        </div>

                        <div className="progress-step">
                            <div className="circle">
                                <img src={imgIconProgress} alt="Step 4" />
                            </div>
                            <div className="label">{resources?.ProgressCheckout}</div>
                        </div>
                    </div>
                </div>

                <div className="container wrapper">
                    <div className="row fw-bold text-pink mt-5">
                        <div className="d-flex align-items-start">
                            <img src={imgIconInfo} alt="Increase" width="18" height="18" className="me-2" />
                            <span dangerouslySetInnerHTML={{ __html: resources?.YouNeedAValidTicketHome }}></span>
                        </div>
                    </div>

                    <div className="row mt-4">
                        <div className="col-md-6">
                            <span className="text-subtitle">{resources?.WorkshopsChoose}</span>
                        </div>
                        <div className="col-md-6 text-end">
                            {showWithoutWorkshopsButton ? ButtonNextWithoutWorkshopsWhite : ButtonNextWithWorkshops}
                        </div>
                    </div>

                    {!loading ? mapTicketTypes() : (
                        <div className="row tickets-box mt-2">
                            <div className="col-md-12">
                                <Loading bgColor="transparent" color="#00726f" resources={resources} />
                            </div>
                        </div>
                    )}

                    <div className="row fw-bold text-pink mt-4">
                        <div className="d-flex align-items-start">
                            <img src={imgIconInfo} alt="Increase" width="18" height="18" className="me-2" />
                            <span>{resources?.WorkshopsInfo}</span>
                        </div>
                    </div>

                    {!showWithoutWorkshopsButton ? (
                        <div className="row mt-4">
                            <div className="col-6">
                                <button className="btn btn-custom" onClick={() => onBackClick()}>{resources?.Back}</button>
                            </div>
                            <div className="col-6 text-end">
                                {ButtonNextWithWorkshops}
                            </div>
                        </div>
                    ) : (
                        <div className="row mt-4">
                            <div className="col-6">
                                <button className="btn btn-custom" onClick={() => onBackClick()}>{resources?.Back}</button>
                            </div>
                            <div className="col-6 text-end">
                                <button
                                    className="btn btn-custom btn-custom-workshops"
                                    onClick={() => {
                                        //skip sunday workshop if order doesnt contain sunday tickets
                                        if (countSundayTickets > 0) {
                                            navigate(`/${language}/workshops-sunday`);
                                        } else {
                                            navigate(`/${language}/address`);
                                        }
                                    }}
                                >
                                    {resources?.Next}
                                </button>
                            </div>
                        </div>
                    )}

                    <div className="row mt-5">
                        <div className="col-md-12 text-center">
                            <p className="mt-4">
                                <small style={{ color: 'grey', fontSize: '10px' }}>powered by <a style={{ color: 'grey', textDecoration: 'none', fontSize: '13px' }} href="https://organizer.ticketino.com/de" target="_blank">TICKETINO</a></small>
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <Footer language={language} />
        </>
    )
}

export default WorkshopsSaturday